import axios from 'axios'
import React, {FC, useContext, useEffect, useState} from 'react'
import {ILanguage} from '../types/common'
import {ChartData} from '../types/ChartData'
import {Periods} from '../types/Periods'
import LineChart from '../common/LineChart'
import {FundProfileContext} from './ctx/FundProfileContext'

const Layout: FC<{
    language: ILanguage
    fund: string
}> = ({language, fund}) => {
    const localCtx: any = useContext(FundProfileContext)
    const [chartItems, setChartItems] = useState([])
    const [chartData, setChartData] = useState<ChartData>({
        begin: '',
        end: '',
        currency: [],
        relativePeriods: {} as Periods,
        valuation_dates: [],
        data: [],
        holiday: [],
    })

    useEffect(() => {
        axios
            .get<ChartData>(`${process.env.REACT_APP_API_BASE_URL}/api/fund/profile/${fund}`, {
                headers: {
                    Accept: 'application/json',
                },
                auth: {
                    username: `${process.env.REACT_APP_API_USERNAME}`,
                    password: `${process.env.REACT_APP_API_PASSWORD}`,
                },
            })
            .then((result) => {
                const holiday = result.data.holiday?.map((item) => {
                    return new Date(item)
                })

                localCtx.setHoliday(holiday)

                setChartData(result.data)

                if (result.data.data.length > 0) {
                    setChartItems([result.data.data[0].id as never])
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])

    return (
        <>
            {chartData.data?.length > 0 && (
                <LineChart
                    chartData={chartData}
                    language={language}
                    chartItems={chartItems}
                    setChartItems={setChartItems}
                    chartMode="profile"
                    ctx={localCtx}
                    sortedComparedRows={[]}
                    selectedRateOfReturnOptions={[]}
                />
            )}
        </>
    )
}

export default Layout
